import styled from 'styled-components';

type ButtonProps = {
  height?: string;
  width?: string;
  padding?: string;
  background?: string;
  hoverBackground? :string;
  hoverColor?: string;
  textColor?: string;
  borderRadius?: string;
  gap?: string;
  active?: boolean;
  disabled?: boolean;
};

export const Button = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.height || '40px'};
  width: ${(props) => props.width || ''};
  padding: ${(props) => props.padding || '11px 16px'};
  gap: ${(props) => props.gap || '8px'};
  background: ${(props) => props.background || props.theme.colors.widget_background};
  border-radius: ${(props) => props.borderRadius || '6px'};
  cursor: pointer;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  color: ${(props) => props.textColor || (props.active
    ? props.theme.colors.main_cta : props.theme.colors.text)};
  
  p {
    font-family: 'Manrope', sans-serif;
    font-size: 13px;
    text-align: center;
    text-wrap: nowrap;
  }
  
  &:hover {
    color: ${(props) => props.hoverColor || props.theme.colors.main_cta};
    background: ${(props) => props.hoverBackground || props.theme.colors.widget_hover_background};
    transition: all .2s ease-in;
  }
  
  &:disabled {
    cursor: default;
    opacity: .5;

    &:hover {
      background: ${(props) => props.theme.colors.widget_background};
    }
  }
`;
